import { CRS_TYPE_SELECTION, CRS_STATUSES_SELECTION, CRS_SEARCH_TITLE_PAGE, CRS_UNIT_TYPE } from '../action/types'
import { CRS_REQUEST_STATUS, CRS_SEARCH_DEFAULT_TITLE_PAGE, CRS_REQUEST_SELECTION, CRS_UNIT_TYPE_SELECTION } from '../../utils/surveyLiterals'
const initialState = {
    crsSelection: CRS_REQUEST_SELECTION,
    statuses: CRS_REQUEST_STATUS,
    searchTitlePage: CRS_SEARCH_DEFAULT_TITLE_PAGE,
    unitSelection: CRS_UNIT_TYPE_SELECTION
}

export default function campaignReducer(state = initialState, action) {
    switch (action.type) {
        case CRS_TYPE_SELECTION:
            return {
                ...state,
                crsSelection: action.payload
            }
        case CRS_STATUSES_SELECTION:
            return {
                ...state,
                statuses: action.payload
            }
        case CRS_SEARCH_TITLE_PAGE:
            return {
                ...state,
                searchTitlePage: action.payload
            }
            case CRS_UNIT_TYPE:
            return {
                ...state,
                unitSelection: action.payload
            }
        default:
            return state

    }
}